<div class="body">

    <mat-toolbar class="ams-toolbar">
        <mat-icon class="main-icon">play_arrow</mat-icon>
        <span [innerHtml]="title"></span>
        <span class="spacer"></span>
        <button mat-icon-button (click)="close()" color="warn" *ngIf="(service.transactionStatus$|async) !== IssueTransactionStatus.Started">
            <mat-icon>close</mat-icon>
        </button>
    </mat-toolbar>

    <div class="content">

        <mat-horizontal-stepper [selectedIndex]="" (selectionChange)="stepperChanged($event)">

            <ng-container *ngFor="let step of (service.steps$|async|visibleSteps); let i = index">

                <mat-step>

                    <ng-template matStepLabel>{{step.title()|async}}</ng-template>

                </mat-step>

            </ng-container>

        </mat-horizontal-stepper>

        <div class="dynamic-content-wrapper">

            <ng-template #dynamicInner></ng-template>
            
        </div>

    </div>

    <div class="footer" [ngClass]="{
        'error': (service.transactionStatus$|async) === IssueTransactionStatus.Error
    }">

        <ng-container *ngIf="(service.transactionStatus$|async) === IssueTransactionStatus.Initial">

            <button mat-raised-button (click)="previousStep()">
                Zurück
            </button>
    
            <div class="spacer"></div>
    
            <button mat-raised-button (click)="nextStep()">
                Weiter
            </button>
            
            <button mat-raised-button color="primary" class="execute-transaction-button" (click)="executeTransaction()">
                Transaktion ausführen
            </button>

        </ng-container>

        <ng-container *ngIf="(service.transactionStatus$|async) === IssueTransactionStatus.Succeeded">

            <div class="spacer"></div>

            <button mat-raised-button color="primary" (click)="close()">
                Abschließen
            </button>

        </ng-container>

        <ng-container *ngIf="(service.transactionStatus$|async) === IssueTransactionStatus.Error">

            <div class="spacer"></div>

            <button mat-raised-button color="primary" (click)="close()">
                Dialog schließen
            </button>

        </ng-container>

    </div>

</div>
